var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',_vm._g(_vm._b({key:_vm.key,staticClass:"fu-table"},'el-table',_vm.$attrs,false),_vm.$listeners),[_c('fu-table-body',{attrs:{"columns":_vm.columns}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }